import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Button, Icon } from 'grab-ui';
import styles from './styles.less';
import Filters from './filters';

const ActionRow = ({
  shop,
  metadata,
  selectedLocationID,
  onTimeRangeChange,
  onShippingTypeChange,
  onSelectedLocationChange,
  doForceRefresh,
}) => (
  <div className={styles.actionRow}>
    <Filters
      shop={shop}
      metadata={metadata}
      selectedLocationID={selectedLocationID}
      onTimeRangeChange={onTimeRangeChange}
      onShippingTypeChange={onShippingTypeChange}
      onSelectedLocationChange={onSelectedLocationChange}
    />
    <Button className={styles.refreshButton} onClick={doForceRefresh}>
      <Icon type={'sync'} /> {I18n.t('shopify.orders.refresh')}
    </Button>
  </div>
);

ActionRow.propTypes = {
  shop: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  selectedLocationID: PropTypes.shape({}).isRequired,
  doForceRefresh: PropTypes.func.isRequired,
  onTimeRangeChange: PropTypes.func.isRequired,
  onShippingTypeChange: PropTypes.func.isRequired,
  onSelectedLocationChange: PropTypes.func.isRequired,
};

export default ActionRow;
